/* Links externos abrem em nova aba.
   Externo = link http:// ou https:// de domínio diferente do site aberto (inclusive os
   outros portais da rede); www. e sem www. contam como o mesmo site.
   Ignora: mesmo domínio (links internos e âncoras #), mailto:, tel: e outros protocolos.
   Nunca sobrescreve: só põe target="_blank" se o link não tiver target, e só acrescenta
   "noopener" ao rel se ainda não houver, mantendo o que já existe (ex.: "sponsored"). */
(function () {
    function dominio(host) {
        return String(host || '').toLowerCase().replace(/^www\./, '');
    }

    var site = dominio(window.location.hostname);

    document.querySelectorAll('a[href]').forEach(function (link) {
        var url;
        try {
            url = new URL(link.getAttribute('href'), window.location.href);
        } catch (e) {
            return; // endereço inválido
        }

        if (url.protocol !== 'http:' && url.protocol !== 'https:') return; // mailto:, tel:…
        if (dominio(url.hostname) === site) return; // interno (inclui âncoras)

        if (!link.hasAttribute('target')) {
            link.setAttribute('target', '_blank');
        }

        var rel = (link.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
        var temNoopener = rel.some(function (valor) { return valor.toLowerCase() === 'noopener'; });
        if (!temNoopener) {
            rel.push('noopener');
            link.setAttribute('rel', rel.join(' '));
        }
    });
})();
